import { useMemo } from "react";
import { without } from "lodash";
import { useActiveWorkspaceRole } from "../../hooks/permissions/useActiveWorkspaceRole";
import {
    UserWorkspaceRole,
    userWorkspaceRolesInOrder,
} from "../../common/userWorkspaceRoles";
import { WORKSPACE_ROLES_LABELS } from "../../common/constants";
import { CustomSelectOption } from "../forms/CustomSelect/CustomSelect";
import { AssignableWorkspaceRole, workspaceLevelRoleDescription } from "./lib";
import styles from "./MemberManagement.module.scss";

export function useAssignableWorkspaceLevelRoleOptions(): CustomSelectOption[] {
    const workspaceRole = useActiveWorkspaceRole();

    return useMemo(() => {
        if (!workspaceRole) {
            return [];
        }

        const assignableRoles = without(
            userWorkspaceRolesInOrder.slice(
                userWorkspaceRolesInOrder.indexOf(workspaceRole),
            ),
            UserWorkspaceRole.PRIMARY_ADMIN,
        ) as AssignableWorkspaceRole[];

        return assignableRoles.map((role) => ({
            value: role,
            label: WORKSPACE_ROLES_LABELS[role],
            renderAddon: () => (
                <span className={styles.roleInfoAddon}>
                    {workspaceLevelRoleDescription[role]}
                </span>
            ),
        }));
    }, [workspaceRole]);
}
